import React from "react"
import { Box, BoxProps } from "@chakra-ui/react"

type Props = {
  gutter?: boolean
} & BoxProps

const Column: React.FC<Props> = ({ children, gutter = true, ...props }) => {
  return (
    <Box px={gutter ? "5px" : 0} verticalAlign="top" display="inline-block" {...props}>
      {children}
    </Box>
  )
}

export default Column
